export default __webpack_public_path__ + "static/media/6.e68b8f38.webp";